import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRepositoryService } from '../core/http-repository.service';
import { User } from '../admin/user/user-model';
import { UserProfileService } from '../user-profile/user-profile.service';
import { SubSink } from 'subsink';
import { AntiForgeryTokenService } from '../auth/anti-forgery-token.service';
import { Company } from '../companies/company/company.model';
import { map } from 'rxjs/operators';
import { UserCompanyService } from './user-company.service';
import { CompanyService } from '../companies/company-edit/company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit, OnDestroy {
  private user: User;
  private subs = new SubSink();
  private companies: Company[] = [];
  private selectedcompanyId: number;
  private selectedCompanyImg: string;
  private selectedCompanyCode: string;
  private isDev: boolean = false;
  private isAdmin: boolean = false;
  private isManager: boolean = false;
  private isUser: boolean = false;

  constructor(private router: Router, private repository: HttpRepositoryService,
    private userService: UserProfileService,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService,
    private companyEditService: CompanyService) { }

  ngOnInit() {
    this.subs.sink = this.repository.get<User>('api/User/LoggedIn').subscribe(resp => {
      this.user = resp.data;

      this.isAuthorized(this.user.roleIds)

      this.userService.changeUserImg(resp.data.image);
      this.subs.sink = this.userService.currentUserImg.subscribe(resp => this.user.image = resp);

      this.userService.changeUserFirstName(resp.data.firstName);
      this.subs.sink = this.userService.currentUserFirstName.subscribe(resp => this.user.firstName = resp);

      this.userService.changeUserLastName(resp.data.lastName);
      this.subs.sink = this.userService.currentUserLastName.subscribe(resp => this.user.lastName = resp);

      this.subs.sink = this.repository.get<Company[]>('api/User/UserCompanies?' + this.user.companyIds.map(x => 'ids=' + x + '&').join("")).pipe(map(x => x)).subscribe(resp => {
        if (resp.hasErrors) {

        } else {
          this.companies = resp.data;

          if (this.companies.length > 0) {
            this.companyService.changeSelectedCompany(this.companies[0].id)
            this.selectedcompanyId = this.companies[0].id;
            this.selectedCompanyImg = this.companies[0].image;
            this.selectedCompanyCode = this.companies[0].code;
            this.companyService.changeSelectedCompanyCode(this.selectedCompanyCode);
          }

          this.subs.sink = this.companyEditService.currentCompany.subscribe(companyResp => {
            let company = this.companies.find(x => x.id == companyResp.id);

            if (company) {
              company.image = companyResp.image;
              company.code = company.code;

              if (this.selectedcompanyId == company.id) {
                this.selectedCompanyImg = company.image;
                this.selectedCompanyCode = company.code;
              }
            }

          });
        }
      });
    });
  }

  searchContacts(searchStr) {
    let query = btoa(encodeURI(searchStr));

    if (query != '')
      this.router.navigate(['/contact/search', { search: query }], { skipLocationChange: false });
  }

  onEnterKey(event: Event, searchStr) {
    event.preventDefault();
    event.stopPropagation();

    this.searchContacts(searchStr);
  }

  private selectCompany(event: any) {
    this.selectedcompanyId = event.target.value;
    let company = this.companies.find(x => x.id == this.selectedcompanyId);

    if (company) {
      this.selectedCompanyImg = company.image;
      this.selectedCompanyCode = company.code;
    }

    this.companyService.changeSelectedCompany(parseInt(event.target.value));
    this.companyService.changeSelectedCompanyCode(this.selectedCompanyCode);

    $('#selectCompanyDropdown').dropdown('toggle');
  }

  private userProfile(e: Event) {
    this.router.navigate(['/userprofile']);

    $('.dropdown-menu').removeClass('show');
  }

  private isAuthorized(roles: number[]) {
    for (let i = 0; i < roles.length; i++) {
      switch (roles[i]) {
        case 1:
          this.isDev = true;
          break;
        case 2:
          this.isAdmin = true;
          break
        case 3:
          this.isManager = true;
          break;
        case 4:
          this.isUser = true;
          break;
        default:
          this.isDev = false;
          this.isAdmin = false;
          this.isManager = false;
          this.isUser = false;
          break;
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
